// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1HreH","logo":"styles_logo__1Igfy","black":"styles_black__3WxSG","white":"styles_white__2zYsN","active":"styles_active__23FSs"};